import { Injectable } from '@angular/core';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { PurchaseRegistryPrintingQuery, PurchaseRegistryPrintingQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PurchaseRegistryPrintingQuery)
@Wrapper(PurchaseRegistryPrintingQueryHandlerBase)
export class PurchaseRegistryPrintingQueryHandler {
    public constructor(
        http: Http
    ) { }
}
